import { IProfileExtraResponse } from '../..';
import { i18n } from '../../i18n-handler/handler/i18n';
import { ISiretExtraResponse } from '../../interfaces/siret/ISiretExtra';
import { IPermission } from '../interfaces/IPermission';
import { IPermissionMessage } from '../interfaces/IPermissionMessage';

let lang = 'fr';

export function viewDashboardAvailableMissions(validationStep: number): IPermission {
    const can = validationStep === 0;
    return {
        can,
    };
}

export function viewDashboardMissions(profile: IProfileExtraResponse): IPermission {
    const can = profile.user.data.confirmed === true;
    return {
        can,
    };
}

export function viewDocs(dataSiret: ISiretExtraResponse): IPermissionMessage {
    const can = !(dataSiret.siret === undefined || dataSiret.siret === null);
    return {
        can,
        message: can === true ? '' : `${i18n.t('permissions.extra-view-docs', { lng: lang })}`,
    };
}

export function viewIBAN(profile: IProfileExtraResponse): IPermissionMessage {
    const can = profile.user.validationStep === 0 || profile.user.validationStep > 1;
    return {
        can,
        message: can === true ? '' : `${i18n.t('permissions.extra-view-iban', { lng: lang })}`,
    };
}

export function viewInvoices(profile: IProfileExtraResponse): IPermission {
    const can =
        (profile.user.validationStep === 0 && profile.user.data.confirmed === true) ||
        profile.user.data.blocked === true;
    return {
        can,
    };
}

export function viewMissions(profile: IProfileExtraResponse): IPermission {
    const can = profile.user.validationStep === 0 && profile.user.data.confirmed === true;
    return {
        can,
    };
}

export function viewNotifications(profile: IProfileExtraResponse): IPermission {
    const can = profile.user.validationStep === 0 && profile.user.data.confirmed === true;
    return {
        can,
    };
}

export function viewPayment(profile: IProfileExtraResponse): IPermission {
    const can = profile.user.validationStep === 0 || profile.user.validationStep > 1;
    return {
        can,
    };
}

export function viewProfile(profile: IProfileExtraResponse): IPermission {
    const can = profile.user.validationStep === 0 && profile.user.data.confirmed === true;
    return {
        can,
    };
}

export function viewProfileCompletion(validationStep: number): IPermission {
    const can = validationStep > 0;
    return {
        can,
    };
}

export function viewRatings(profile: IProfileExtraResponse): IPermission {
    const can = profile.user.validationStep === 0 && profile.user.data.confirmed === true;
    return {
        can,
    };
}

export type ExtraPermissionsReturn = {
    viewDashboardMissions: Function;
    viewDashboardAvailableMissions: Function;
    viewProfileCompletion: Function;
    viewIBAN: Function;
    viewDocs: Function;
    viewMissions: Function;
    viewRatings: Function;
    viewInvoices: Function;
    viewProfile: Function;
    viewPayment: Function;
    viewNotifications: Function;
};

export const extraPermissions = (_lang: string): ExtraPermissionsReturn => {
    lang = _lang;

    return {
        viewDashboardMissions,
        viewDashboardAvailableMissions,
        viewProfileCompletion,
        viewIBAN,
        viewDocs,
        viewMissions,
        viewRatings,
        viewInvoices,
        viewProfile,
        viewPayment,
        viewNotifications,
    };
};
